<template>
  <v-dialog v-model="editNameDialog" persistent max-width="500">
    <template v-slot:activator="{ on, attrs }"
      ><div v-on="on" v-bind="attrs"><EditIcon /></div></template
    ><v-card class="dialogWrapper"
      ><div class="dialogTitleWrapper">
        <EditIcon />
        <div class="dialogTitle">{{ header }}</div>
      </div>
      <div class="dialogWarn">{{ title }}</div>
      <div class="dialog-inputWrapper">
        <input
          :type="inputType"
          autocomplete="off"
          :placeholder="$t('profile.namePlaceholder')"
          name="editName"
          v-model="text"
        />
        <span v-if="inputErrorText !== ''" class="fi-errorInput">{{
          inputErrorText
        }}</span>
      </div>
      <div class="dialogActionWrapper">
        <v-btn
          color="darken-1"
          class="closeBtn"
          text
          @click="editNameDialog = !editNameDialog"
          >{{$t('profile.closeBtn')}}</v-btn
        >
        <v-btn class="createBtn" text @click="submit" :loading="loading"
          >{{$t('profile.changeBtn')}}</v-btn
        >
      </div></v-card
    ></v-dialog
  >
</template>

<script>
import EditIcon from "../components/icons/EditIcon";
export default {
  name: "ChangeNameDialog",
  components: {
    EditIcon,
  },
  props: {
    header: String,
    title: String,
    placeholder: String,
    inputType: String,
    onSubmit: Function,
    editName: String,
  },
  mounted() {
    switch (this.inputType) {
      case "username":
        this.type = "text";
        break;
      case "phoneNumber":
        this.type = "number";
        break;
      default:
        break;
    }
  },
  watch: {
    editNameDialog: function() {
      if (this.editNameDialog) {
        this.text = this.editName;
      }
    },
    text: function() {
      switch (this.inputType) {
        case "username":
          this.inputErrorText = this.usernameValidator(this.text);
          break;
        case "phoneNumber":
          this.inputErrorText = this.phoneNumbarValidator(this.text);
          break;
        default:
          break;
      }
    },
  },
  data: () => ({
    editNameDialog: false,
    text: "",
    inputErrorText: "",
    loading: false,
    type: "",
  }),
  methods: {
    submit() {
      if (this.inputErrorText === "") {
        this.loading = true;
        this.onSubmit(this.text);
        this.loading = false;
        this.editNameDialog = false;
      }
    },
    usernameValidator(name) {
      if (name.length <= 1) {
        return this.$t('profile.nameValidator');
      }
      const regex = new RegExp("[а-яА-ЯӨөҮүa-zA-Z-]");
      if (!regex.test(name)) {
        return this.$t('profile.nameRegex');
      }
      if (name.length > 25) {
        return this.$t('profile.nameLengthValidator');
      }
      return "";
    },
    phoneNumbarValidator(number) {
      const regex = new RegExp("[0-9]{8}");
      if (!regex.test(number)) {
        return this.$t('profile.phoneValidator');
      }
      return "";
    },
  },
};
</script>
<style scoped>
.dialog-inputWrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  /* height: 56px; */
}
.dialog-inputWrapper input {
  height: 40px;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
  font-weight: 400;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  line-height: 16px;
  transition: 0.4s ease-out;
}

.dialog-inputWrapper input:focus {
  border: 2px solid #777ff6 !important;
  outline: none;
}

.dialog-inputWrapper input:hover {
  border: 2px solid #777ff6 !important;
  transition: 0.4s ease-out;
  outline: none;
}
</style>
